'use strict';

const config = {
    toggle: '.js-password-toggle',
    selector: '.js-password-has-toggle',
    toggleClass: 'o-password-toggle--off'
};

var $selector = $(config.selector);

$selector.parent().css('position', 'relative');
$selector.after('<span class="js-password-toggle o-password-toggle"></span>');

$(config.toggle).on('click', function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($selector.attr('type') === "password") {
        $selector.attr('type', 'text');
        $this.addClass(config.toggleClass);
    } else {
        $selector.attr('type', 'password');
        $this.removeClass(config.toggleClass);
    }
});



// WEBPACK FOOTER //
// ./src/js/components/password-toggle.js